import styled from "styled-components";
import {radii} from "theme/tokens";

/** Externalized styles for {@link ./PanelLoading} — the in-panel body skeleton (ui#150). */

/**
 * The skeleton column, sitting where a feature body renders inside the sheet.
 *
 * No insets of its own since ui#1038: it used to clear the floating top bar and pad its own gutters,
 * which the non-modal panel needed because it ran the full height of the viewport under the nav. Inside
 * a modal sheet the header sits above it and the sheet's scroll region owns the gutters, so both insets
 * became dead space that made the loading state jump when the real body replaced it.
 */
export const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	padding-bottom: 18px;
`;

/** A framed card mirroring the private pages' list card (token surface + border + large radius). */
export const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	padding: 20px;
	background: ${({theme}) => theme.tokens.card2};
	border: 1px solid ${({theme}) => theme.tokens.cardBorder};
	border-radius: ${radii.card};
`;
